import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "next-themes";

export default function Logo({ size = "md", className = "", forceDark = false, forceLight = false, noLink = false }) {
  const { theme } = useTheme();
  const isDark = forceLight ? false : (forceDark || theme === "dark");
  const heights = { sm: 44, md: 88, lg: 120 };
  const h = heights[size] || 88;
  const src = isDark ? "/orello-lockup-light.png" : "/orello-lockup-dark.png";

  const img = (
    <img
      src={src}
      alt="Orello"
      style={{ height: h, width: "auto", display: "block", objectFit: "contain" }}
    />
  );

  if (noLink) {
    return (
      <div className={`inline-flex items-center ${className}`} data-testid="orello-logo" style={{ flexShrink: 0 }}>
        {img}
      </div>
    );
  }

  return (
    <Link to="/" className={`inline-flex items-center ${className}`} data-testid="orello-logo" style={{ flexShrink: 0 }}>
      {img}
    </Link>
  );
}
